
export const despesaDetutivelAnualLimite = 17640.00 // 16754.34

export const percDespesaDetutivelRendaTributavel = 20

export const percPGBL = 12

export const tabelaIR = [
    {
        baseCalculoAte: 29145.60, //24511.92,
        aliquota: 0,
        parcelaDeduzir: 0
    },
    {
        baseCalculoAte: 33919.80, //33919.80,
        aliquota: 7.5,
        parcelaDeduzir: 2185.92, //1838.39
    },
    {
        baseCalculoAte: 45012.60,
        aliquota: 15,
        parcelaDeduzir: 4729.91, //4382.38
    },
    {
        baseCalculoAte: 55976.16,
        aliquota: 22.5,
        parcelaDeduzir: 8105.85, //7758.32
    },
    {
        baseCalculoAte: null,
        aliquota: 27.5,
        parcelaDeduzir: 10904.66, //10557.13
    },
]